import React, { FC, memo } from "react";
// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
// styles
import { ContainerV2 } from "../styles";
// types
import { BottomSheetData } from "@super-ui/components/m2c-swiggy-black-halfcard/types";
// helpers
import { isEmpty } from "@swiggy-private/js-utils";
// constants
import { M2C_HALFCARD_TEST_IDS } from "@super-ui/components/m2c-swiggy-black-halfcard/constants";

const VariantV2: FC<BottomSheetData> = ({ contentImage }) => {
    return (
        <>
            {!isEmpty(contentImage) && (
                <ContainerV2 data-testid={M2C_HALFCARD_TEST_IDS.CONTENT_V2}>
                    <Image cloudinaryId={contentImage} />
                </ContainerV2>
            )}
        </>
    );
};

export default memo(VariantV2);
